import { put, takeLatest } from 'redux-saga/effects';
import { Space, SpaceAPI } from 'api/space/space';
import { StoreActionProps } from 'data/core';
import { UpdateSpacePayload, editSpaceSagaAction } from '../actions';
import { editStart, editSuccess, editFailure } from '../index';

function* editSpaceSaga(action: StoreActionProps<UpdateSpacePayload>) {
  const { payload } = action;

  try {
    const { spaceId, ...rest } = payload;

    yield put(editStart(spaceId));
    const response = (yield SpaceAPI.updateSpace(spaceId, rest)) as Space;

    yield put(editSuccess(response));
  } catch (error) {
    yield put(editFailure(''));
  }
}

export function* watchEditSpaceSaga(): Generator {
  yield takeLatest(editSpaceSagaAction.type, editSpaceSaga);
}
